<mb-progress-bar class="progress-bar progress-bar--top-fullwidth"></mb-progress-bar>
@if (!(isLanding$ | async)) {
    @if ((initialData$ | async); as initialData) {
      <div class="search-box__content">
        @if (initialData && (context$ | async); as context) {
          @if (isMobile$ | async) {
            <am-searchbox-summary [searchboxData]="{ initialData, context }"></am-searchbox-summary>
          } @else {
            <am-search-box [country]="context?.site" [brand]="context?.brand" [channel]="context?.channel"
              [initialData]="initialData" [product]="'hotels'" [dataType]="'model'"
              [allowDollar]="context?.allowDollar" [disableARS]="context?.disableARS"
              (modelSearch)="handleSearch($event)">
            </am-search-box>
          }
        }
      </div>
    } @else {
      <div class="search-box__content">
        <am-searchbox-skeleton></am-searchbox-skeleton>
      </div>
    }
}
<div class="site-content">
  <router-outlet></router-outlet>
</div>